import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { midCTA } from "../../../mocks/yokohamaData";

export default function MidCTA() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Yokohama%20Minato%20Mirai%20bay%20area%20at%20twilight%20with%20warm%20orange%20and%20deep%20navy%20gradient%20sky%2C%20city%20lights%20beginning%20to%20sparkle%20on%20water%20surface%2C%20helicopter%20perspective%2C%20luxury%20travel%20atmosphere%2C%20wide%20panoramic%20composition%2C%20no%20text%2C%20editorial%20photography&width=1920&height=500&seq=ymidcta01&orientation=landscape"
        alt="横浜夕景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-airdoa-navy/60" />

      <div className="relative z-10 px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <ScrollReveal direction="up">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-serif font-semibold text-white leading-tight">
              {midCTA.title}
            </h2>
            <p className="mt-3 text-sm md:text-base text-white/70">
              {midCTA.subtitle}
            </p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              {midCTA.ctas.map((cta) => {
                if (cta.type === "primary") {
                  return (
                    <Link key={cta.href} to={cta.href} className="btn-primary">
                      {cta.label}
                    </Link>
                  );
                }
                return (
                  <Link key={cta.href} to={cta.href} className="btn-ghost">
                    {cta.label}
                  </Link>
                );
              })}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
